export default 'https://tme.understood.org/assets/UnderstoodSans-Heavy.c47660e6.png'